import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    init: function() {
      const lines = document.querySelectorAll( '[data-component="process-list"] .process-list__line' );

      const setLineBottom = () => {
        lines.forEach( ( line ) => {
          const ol = line.closest( 'ol' );
          const lastLi = ol.querySelector( 'li:last-child' );
          const bottom = ol.offsetHeight - ( lastLi.offsetTop + 24 + 25 );
          line.style.bottom = Math.max( 0, bottom ) + 'px';
        } );
      };

      setLineBottom();
      window.addEventListener( 'resize', setLineBottom );

      if ( !window.hasMotion ) return;

      lines.forEach( ( line ) => {
        gsap.fromTo( line,
            {clipPath: 'inset(0 0 100% 0)'},
            {
              clipPath: 'inset(0 0 0% 0)',
              ease: 'none',
              scrollTrigger: {
                trigger: line.closest( 'ol' ),
                start: 'top 80%',
                end: 'bottom 60%',
                scrub: true,
              },
            },
        );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'process-list', COMPONENT );
} )( app );
